import {loader} from "./scripts/loader";
import {init_phone} from "./scripts/phone";

export function init_testimonial_school_form () {
    const urlParams = new URLSearchParams(window.location.search);
    if (window.request_info && window.request_info.show === '1' && urlParams.has('testimonial') && urlParams.get('testimonial') === '1'){
        get_testimonial_school_form();
    }

    function get_testimonial_school_form(){
        const schoolId = $('#btn-request_form').data('school-id');

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'testimonial_school_form',
                school_id: schoolId,
                email: urlParams.get('e'),
                _ajax_nonce: window.glob_obj.testimonial_school_form_nonce
            },
            beforeSend: function(){
                loader.show()
            },
            success: function (response) {
                loader.hide();

                $('body').append(response.html);
                $('#testimonial-form-modal').modal().on('hidden.bs.modal', function (e) {
                    $(this).remove();
                }).on('shown.bs.modal', function (e){
                    init_phone();
                    if (window.grecaptcha && window.glob_obj.is_logged_in === ''){
                        window.grecaptcha.render('g-recaptcha', {
                            'sitekey' : window.glob_obj.recaptcha_site_key
                        });
                    }
                });
                init_testimonial_school_form_submission()
            },
            error: function(error){
                loader.hide()
                console.log(error);
            }
        });
    }
}

function init_testimonial_school_form_submission(){
    $('#testimonial-form').submit(function (e){
        e.preventDefault();
        let formData = new FormData($(this)[0]);

        formData.append('action', 'testimonial_school_form_submit');
        formData.append('_ajax_nonce', window.glob_obj.testimonial_school_form_submit_nonce);
        $.ajax({
            type: "POST",
            url: window.glob_obj.ajaxurl,
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            beforeSend: function(){
                $('.contact-form .form-error').remove();
                loader.show()
            },
            success: function(data, textStatus, jqXHR) {
                loader.hide()
                if (data.errors){
                    const errors = data.errors
                    const keys = ['name', 'phone'];
                    Object.keys(errors).map(function(key, index) {
                        if (keys.includes(key)){
                            $(`.contact-form input[name=${key}], .contact-form select[name=${key}], .contact-form textarea[name=${key}]` ).closest('.form-group').append('<span class="form-error">' + errors[key] + '</span>');
                        } else {
                            $('<span class="form-error">' + errors[key] + '</span>').insertAfter(
                                $(`.contact-form input[name=${key}], .contact-form select[name=${key}], .contact-form textarea[name=${key}]`)
                            );
                        }
                    });
                    if (data.errors.global){
                        $('<p class="form-error">' + data.errors.global + '</p>').insertAfter($('.contact-form > fieldset'));
                    }
                }
                if (data.success) {
                    fbq('track', 'Lead');
                    $('#testimonial-form').closest('.modal-content').find('.modal-header').remove();
                    $('#testimonial-form').html('Thank You!');
                }
            },
            error: function(data, textStatus, jqXHR) {
                loader.hide()
                console.log(error);
            },
        })
    })
}

